angular.module('dnecom')
    .controller('PromoCodeProcessController', ["$scope", "$rootScope", "$http", "notifications", "$timeout", function PromoCodeProcessController($scope, $rootScope, $http, notifications, $timeout) {
        var defaults = {
            id: 0,
            type: null,
            limitPerCustomer: null,
            useExpiration: null
        };

        $scope.errorMessages = [];

        $scope.store = TemplateData.value('store');
        $scope.products = TemplateData.value('products');
        $scope.promoCode = angular.merge(defaults, TemplateData.value('promoCode'));

        if ($scope.promoCode.bonus) {
            $scope.promoCode.bonus = parseFloat($scope.promoCode.bonus);
        }

        if ($scope.promoCode.minOrderValue) {
            $scope.promoCode.minOrderValue = parseFloat($scope.promoCode.minOrderValue);
        }

        if ($scope.promoCode.usageLimit) {
            $scope.promoCode.usageLimit = parseFloat($scope.promoCode.usageLimit);
        }

        $scope.promoCode.useUsageLimit = $scope.promoCode.usageLimit > 0 ? "1" : "0";
        $scope.promoCode.limitPerCustomer = $scope.promoCode.limitPerCustomer > 0 ? "1" : "0";

        var originalPromoCode = angular.copy($scope.promoCode);

        $scope.saving = false;

        $scope.promoCodeChanged = function () {
            return !angular.equals(originalPromoCode, $scope.promoCode);
        };

        $scope.onFieldUpdate = function(key) {
            $scope.form[key].$setValidity('customMessage_' + key, true);
            $scope.form[key].$validate();
        };

        $scope.savePromoCode = function () {
            $scope.saving = true;
            $scope.errorMessages = [];

            var data = {
                'type': $scope.promoCode.type,
                'discountType': $scope.promoCode.discountType,
                'conditionType': $scope.promoCode.conditionType,
                'name': $scope.promoCode.name,
                'bonus': $scope.promoCode.bonus,
                'product': $scope.promoCode.conditionType == 'specific_product' ? _.get($scope.promoCode, 'product.id') : null,
                'minOrderValue': $scope.promoCode.conditionType == 'orders_over' ? $scope.promoCode.minOrderValue : 0,
                'usageLimit': $scope.promoCode.useUsageLimit ? $scope.promoCode.usageLimit : null,
                'limitPerCustomer': $scope.promoCode.limitPerCustomer || 0,
                'useExpiration': $scope.promoCode.useExpiration,
                'dateStart': $scope.promoCode.dateStart || null,
                'dateStop': $scope.promoCode.dateStop || null,
                'properties': $scope.promoCode.properties
            };

            $http
                .put(
                    Routing.generate('promocodes_update', {
                        id: $scope.store.id,
                        promoCodeId: $scope.promoCode.id
                    }),
                    data
                )
                .then(function (response) {
                    if (!response.data.success) {
                        notifications.danger(response.data.message || 'Failed to update promo code.');
                        return;
                    }

                    $scope.promoCode.id = response.data.id;
                    $scope.promoCode.updatedAt = response.data.updatedAt;

                    notifications.success('Promo code saved.');
                }, function (response) {
                    if (response.data.hasOwnProperty('errors')) {
                        $.each(response.data.errors, function(key, value) {
                            if ($scope.form[key]) {
                                $scope.form[key].$invalid = true;
                                $scope.form[key].$touched = true;

                                $scope.errorMessages.push({
                                    type: 'customMessage_' + key,
                                    text: value[0]
                                });

                                $scope.form[key].$setValidity('customMessage_' + key, false);
                            }
                        });

                        notifications.danger('Failed to save promo code.');
                    } else {
                        notifications.danger('Request error.');
                    }
                })
                .finally(function () {
                    $scope.saving = false;
                })
            ;
        };

        $scope.deletePromoCode = function () {
            $http
                .delete(Routing.generate('promocodes_delete', {
                    id: $scope.store.id,
                    promoCodeId: $scope.promoCode.id
                }))
                .success(function (response) {
                    if (!response.success) {
                        notifications.danger(response.message);
                        return;
                    }

                    notifications.success('Promo code deleted.');
                    window.location = Routing.generate('promocodes_index', {id: $scope.store.id});
                })
                .error(function (response) {
                    notifications.danger('Request error.');
                })
            ;
        };

        $scope.deselectProduct = function() {
            $scope.promoCode.product = null;
            $rootScope.$broadcast('angucomplete-alt:clearInput');
        };

        $scope.onProductSelection = function(selectedItem) {
            $scope.promoCode.product = _.get(selectedItem, 'originalObject');
        };

        $scope.onProductSelectionInput = function(input) {
            $scope.specificProductSearch = input;
        };
    }])
;
